// import { Link } from "react-router-dom";
// import PageBanner from "../../PageBanner";
// import SocialMediaSidebar from "../../SocialMediaSidebar";
// import SectionHeader from "../../SectionHeader";
// import ScrollToTopButton from "../../ScrollToTopButton";
// import AG from "../../../assets/images/automated-guidance.png"
// import EmergencyResponse from "../../../assets/images/EmergencyTech.png"

// const OfferingAutomatedGuidance = () => {
//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="Emergency Response"
//         breadcrumb={[
//           { label: "Home", href: "/" },
//           { label: "Offerings" },
//         ]}
//       />
//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Emergency Response @ AJEEVI"
//           shareUrl="https://swmecom.ajeevi.in/smart-segregation"
//         />
//       </div>
//       <div>
//         <ScrollToTopButton />
//       </div>

//       {/* Page content */}
//      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
//   <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//     {/* Summary Section */}
//     <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
//       {/* Text Section */}
//       <div className="md:w-1/2">
//         <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//           Summary
//         </h4>
//         <p className="text-black mb-4 text-lg">
//           Smart pole emergency response systems revolutionize public safety by providing instant communication channels through Emergency Call Boxes (ECB) and real-time alerts via Public Address Systems (PAS). This integrated technology enables faster emergency response and better situational awareness in urban areas.
//         </p>
//         <p className="text-black text-lg">
//           Cities implementing smart pole emergency solutions achieve significant improvements in emergency response times, public safety, and crisis management while creating more secure urban environments.
//         </p>
//       </div>

//       {/* Image Section */}
//       <div className="md:w-1/2">
//         <img
//           src={EmergencyResponse}
//           alt="Smart Pole Emergency Response System"
//           className="w-full h-auto rounded-lg shadow-md"
//         />
//       </div>
//     </div>

//     {/* Introduction Section */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//         Introduction
//       </h4>
//       <p className="text-black mb-4 text-lg">
//         In emergency situations, every second counts. Smart pole emergency systems provide immediate access to help through strategically placed Emergency Call Boxes and real-time public announcements, cutting response times and improving outcomes.
//       </p>
//       <p className="text-black text-lg">
//         By integrating emergency communication directly into urban infrastructure, cities can create safer public spaces with always-available assistance and coordinated emergency notifications.
//       </p>
//     </div>

//     {/* Key Features Section */}
//     <div className="mb-10">
//       <h5 className="text-xl font-semibold mb-4 text-black">
//         Key Features of Smart Pole Emergency Systems:
//       </h5>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//         <li>
//           <strong>Emergency Call Boxes (ECB):</strong> Direct line to emergency services with location identification
//         </li>
//         <li>
//           <strong>Public Address System (PAS):</strong> Real-time emergency announcements and instructions
//         </li>
//         <li>
//           <strong>Automatic Alerting:</strong> Instant notification to authorities when emergency button is pressed
//         </li>
//         <li>
//           <strong>Two-Way Communication:</strong> Live interaction between callers and emergency responders
//         </li>
//         <li>
//           <strong>Integrated Surveillance:</strong> Camera activation during emergency events
//         </li>
//         <li>
//           <strong>Location Precision:</strong> GPS coordinates and pole identification for accurate response
//         </li>
//       </ul>
//     </div>

//     {/* Benefits Section */}
//     <div className="mb-10">
//       <h5 className="text-xl font-semibold mb-3 text-black">
//         Operational Benefits
//       </h5>
//       <p className="text-black text-lg mb-4">
//         Implementing smart pole emergency response delivers measurable improvements:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>40-60% faster emergency response times</li>
//         <li>Improved public perception of safety</li>
//         <li>Reduced crime rates in equipped areas</li>
//         <li>Better coordination during large-scale emergencies</li>
//         <li>24/7 availability of emergency assistance</li>
//         <li>Accurate location data for responders</li>
//       </ul>
//     </div>

//     {/* Implementation Section */}
//     <div className="mb-10">
//       <h5 className="text-xl font-semibold mb-3 text-black">
//         Implementation Considerations
//       </h5>
//       <p className="text-black text-lg mb-4">
//         Successful emergency system deployment requires:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>Strategic placement in high-traffic and high-risk areas</li>
//         <li>Integration with local emergency response networks</li>
//         <li>Redundant power and communication systems</li>
//         <li>Regular testing and maintenance protocols</li>
//         <li>Public awareness campaigns about system availability</li>
//         <li>ADA-compliant design for universal access</li>
//       </ul>
//     </div>

//     {/* Ajeevi's Contribution Section */}
//     <div>
//       <h5 className="text-xl font-semibold mb-3 text-black">
//         Ajeevi's Smart Pole Emergency Solutions
//       </h5>
//       <p className="text-black mb-4 text-lg">
//         Ajeevi offers comprehensive emergency response systems for smart poles:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>
//           <strong>Advanced ECB Systems:</strong> Weather-resistant call boxes with clear audio
//         </li>
//         <li>
//           <strong>Intelligent PAS:</strong> Zone-specific emergency announcements
//         </li>
//         <li>
//           <strong>Integrated Response:</strong> Automatic camera activation and lighting
//         </li>
//         <li>
//           <strong>Reliable Connectivity:</strong> Multiple communication channels
//         </li>
//         <li>
//           <strong>Central Monitoring:</strong> 24/7 oversight of emergency network
//         </li>
//       </ul>
//       <p className="text-black text-lg">
//         Discover how Ajeevi's emergency response solutions can make your city safer. Visit{" "}
//         <a
//           href="http://www.ajeevi.com"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="text-[#00D084] hover:underline"
//         >
//           www.ajeevi.com
//         </a>{" "}
//         for more information.
//       </p>
//     </div>
//   </div>
// </div>
//     </>
//   );
// };

// export default OfferingAutomatedGuidance;


import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import Realtime from "../../../assets/images/realtime.png";
import AlertSystemImage from "../../../assets/images/ecb.png"; // You can rename or change path as per your image asset

const EmergencyAlertSystem = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Emergency Alert System"
        breadcrumb={[{ label: "Home", href: "/" }, { label: "Offerings" }]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Emergency Alert System @ GyanYantram"
          shareUrl="https://gyanyantram.example.com/emergency-alert"
        />
      </div>

      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary Section */}
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
            {/* Text Section */}
            <div className="md:w-1/2">
              <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
                Summary
              </h4>
              <p className="text-black mb-4 text-lg">
                GyanYantram’s Emergency Alert System is designed to instantly respond to emergencies using ECB (Emergency Call Boxes) and PAS (Public Address Systems). These integrated technologies allow authorities to broadcast real-time alerts, warnings, and public safety messages across urban and remote areas.
              </p>
              <p className="text-black text-lg">
                This system empowers quicker communication during natural disasters, accidents, security threats, or public health emergencies—ensuring safety through clear and timely information delivery.
              </p>
            </div>

            {/* Image Section */}
            <div className="md:w-1/2">
              <img
                src={AlertSystemImage}
                alt="Emergency Alert Broadcast"
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
          </div>

          {/* Introduction Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <p className="text-black mb-4 text-lg">
              In emergencies, rapid communication can save lives. GyanYantram’s Emergency Alert System leverages ECB and PAS to disseminate critical messages instantly. The system is strategically installed across urban areas to ensure maximum reach.
            </p>
            <p className="text-black text-lg">
              Whether it’s an evacuation order, traffic alert, or public guidance, alerts are broadcasted in real time to notify citizens and guide them effectively.
            </p>
          </div>

          {/* Key Features Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of Emergency Alert System:
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black">
              <li>
                <strong>Instant Broadcast:</strong> Deliver emergency messages through ECB and PAS across targeted zones
              </li>
              <li>
                <strong>Multi-language Support:</strong> Announcements in regional languages for better understanding
              </li>
              <li>
                <strong>Two-way Communication:</strong> ECBs allow users to contact authorities directly
              </li>
              <li>
                <strong>Integration Ready:</strong> Connects with existing surveillance and monitoring systems
              </li>
              <li>
                <strong>Remote Activation:</strong> Centralized dashboard to manage alerts across the city
              </li>
              <li>
                <strong>Battery Backup:</strong> Operates during power failures and extreme conditions
              </li>
            </ul>
          </div>

          {/* Benefits Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Why It Matters
            </h5>
            <p className="text-black text-lg mb-4">
              GyanYantram’s Emergency Alert System improves public safety and emergency response through:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Faster information dissemination during crises</li>
              <li>Improved coordination among emergency services</li>
              <li>Reduced panic through clear and timely instructions</li>
              <li>Greater reach to vulnerable and remote populations</li>
              <li>Compliance with urban safety and smart city guidelines</li>
            </ul>
          </div>

          {/* Deployment Strategy */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Deployment Strategy
            </h5>
            <p className="text-black text-lg mb-4">
              Effective rollout of this system includes:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Installation at key public locations (markets, schools, highways)</li>
              <li>Integration with city surveillance systems</li>
              <li>Training of emergency personnel and city staff</li>
              <li>Scheduled test alerts and routine system checks</li>
              <li>Public awareness programs on system use</li>
            </ul>
          </div>

          {/* GyanYantram's Role Section */}
          <div>
            <h5 className="text-xl font-semibold mb-3 text-black">
              GyanYantram's Smart Emergency Solutions
            </h5>
            <p className="text-black mb-4 text-lg">
              GyanYantram offers complete emergency alert infrastructure with advanced technology:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                <strong>Integrated ECB & PAS:</strong> Reliable and accessible emergency communication
              </li>
              <li>
                <strong>Smart Control Center:</strong> Centralized alert management and monitoring
              </li>
              <li>
                <strong>Real-time Connectivity:</strong> Syncs with IoT, surveillance, and sensor systems
              </li>
              <li>
                <strong>Public Safety Focused:</strong> Customizable messages for specific situations
              </li>
              <li>
                <strong>Scalable Design:</strong> Expandable for cities of all sizes
              </li>
            </ul>
            <p className="text-black text-lg">
              Explore how GyanYantram’s emergency systems safeguard your city. Visit{" "}
              <a
                href="http://www.gyanyantram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                www.gyanyantram.com
              </a>{" "}
              for more information.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmergencyAlertSystem;
